<script setup lang="ts">
import { onLaunch, onShow, onHide } from '@dcloudio/uni-app'
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'
import VConsole from 'vconsole'

onLaunch(() => {
  console.log('App Launch')
  // #ifdef H5
  uni.preloadPage({ url: '/pages-sub/goods/index' })
  // #ifdef H5

  if (import.meta.env.VITE_SHOW_VCONSOLE === 'true') {
    const vConsole = new VConsole({
      maxLogNumber: 100,
      theme: 'dark',
    })
  }
})
onShow(() => {
  console.log('App Show')
})
onHide(() => {
  console.log('App Hide')
})
</script>

<style lang="scss">
@use '/src/style/ipad/index.scss' as *;
@import '/src/style/index';

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
